var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"qr-container"},[_c('div',[_c('img',{ref:"qr",attrs:{"src":_vm.qrLink}}),_vm._v(" "),_c('icon-button',{staticClass:"print-button",attrs:{"size":"20","icon":"el-icon-printer"},on:{"click":_vm.print}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a646b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/stations/QR.vue
// module id = null
// module chunks = 